<template>
	<div class="m-portlet m-portlet--brand">
		<div class="m-portlet__head">
			<div class="m-portlet__head-caption">
				<div class="m-portlet__head-title">
					<h3 class="m-portlet__head-text">
						Danh sách khóa số hàng ngày (00:00')
					</h3>
				</div>
			</div>
			<div class="m-portlet__head-tools">
				<button @click="this.showLockNumberForm" type="button" class="btn btn-brand m-btn m-btn--custom">Tạo cấu hình</button>
			</div>
		</div>
		<div class="m-portlet__body">
			<!--begin::Section-->
			<div class="m-section">
				<div class="m-section__content">
					<data-table 
						tableId="dailyLockNumber_table"
						:header="this.tableHeader"
						:columns="this.tableColumns"
						:columnDefs="this.columnDefs"
						:columnSearch="this.columnSearch"
						:data="this.locks"
						:onEditRow="this.editDailyLockNumber"
						:onDeleteRow="this.deleteRowLockNumber"
					/>
				</div>
			</div>
			<!--end::Section-->

			<div class="modal fade show" id="tangcoForm" tabindex="-1" role="dialog" aria-labelledby="modalTitle">
				<div class="modal-dialog" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h3 class="modal-title" id="modalTitle">Config khóa số hằng ngày</h3>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div class="modal-body">
							<ul class="nav nav-tabs  m-tabs-line m-tabs-line--success" role="tablist">
								<li class="nav-item m-tabs__item">
									<a class="nav-link m-tabs__link active show" data-toggle="tab" href="#m_tabs_coban" role="tab" aria-selected="true">Cơ bản</a>
								</li>
								<li class="nav-item m-tabs__item">
									<a class="nav-link m-tabs__link" data-toggle="tab" href="#m_tabs_nangcao" role="tab" aria-selected="false">Nâng cao</a>
								</li>
							</ul>
							<div class="tab-content">
								<div class="tab-pane active show" id="m_tabs_coban" role="tabpanel">
									<form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
										<div class="form-group m-form__group row">
											<div class="col-lg-12">
												<span class="m-form__help">Áp dụng toàn bộ cấp dưới</span>
											</div>
											<div class="col-lg-4">
												<input disabled="true" type="text" class="form-control m-input" :value="this.user.code" />
											</div>
											<div class="col-lg-8">
												<input type="text" class="form-control m-input" v-model="subCode" />
											</div>
										</div>
										<div class="form-group m-form__group row">
											<div class="col-lg-12">
												<span class="m-form__help">Nhập vào số cần khóa</span>
												<input type="text" id="_number" class="form-control m-input" placeholder="Nhập số" />
											</div>
										</div>
										<game-info-selection :onlyToday="false" tab="" />
										<div class="form-group m-form__group row">
											<div class="col-lg-12">
												<span class="m-form__help">Nhập điểm giới hạn</span>
												<input type="text" id="limit" class="form-control m-input" placeholder="điểm giới hạn" />
											</div>
										</div>
									</form>
								</div>
								<div class="tab-pane" id="m_tabs_nangcao" role="tabpanel">
									Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scramble.
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
							<button @click="this.doLockNumber" type="button" class="btn btn-primary">Tạo</button>
						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import DataTable from "../DataTable";
	import GameInfoSelection from './GameInfoSelection';

	export default {
		data(){
			let vm = this;

	        return {
	        	"tableHeader": ["Tài khoản","Số đặt","Miền","Đài","Kiểu","Mức giới hạn"],
	        	"columnSearch": [{pos:0}, {pos:1}, {pos:2}, {pos:3}, {pos:4}, {pos:5}],
	        	"tableColumns": [{data: 'user_code'},{data: 'number'},{data: 'game_id'},{data: 'channel_id'},{data: 'prop_id'},{data: 'limit'}],
	        	"columnDefs": [
					{
						targets: 1,
						render: function(data, type, full, meta) {
							let n = data.join(", ");
							return n;
						},
					},
					{
						targets: 2,
						render: function(data, type, full, meta) {
							let g = vm.gameInfo.games[data];
							return g;
						},
					},
					{
						targets: 3,
						render: function(data, type, full, meta) {
							if(data == "") return "Tất cả";
							let channels = [];
							for(let i=0;i<data.length;i++){
								let channel = [];
								for(let j=0;j<data[i].length;j++){
									channel.push(vm.gameInfo.channels[data[i][j]].alias);
								}

								channels.push(channel.join(" - "))
							}
							
							return channels.join(", ");
						},
					},
					{
						targets: 4,
						render: function(data, type, full, meta) {
							if(data == "") return "Tất cả";
							let props = [];
							for(let i=0;i<data.length;i++){
								props.push(vm.gameInfo.props[data[i]]);
							}
							
							return props.join(", ");
						},
					}
				],

	            "today": moment().format('DD/MM/Y'),
	            "locks": [],
	            "subCode": "",
	            "selectedRecord": null
	        }
	    },

	    created(){
    		this.getDailyLockNumber();
    	},

    	components: {
        	'data-table': DataTable,
        	'game-info-selection': GameInfoSelection
        },

    	computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

	    methods: {
	        getDailyLockNumber: function(){
	        	let vm = this;

	        	window.axios.get("admin-panel/tools/daily-locknumber")
	        				.then((res) => {
	        					res = res.data;
	        					vm.locks = res.data;
	        				})
	        				.catch((error) => {

	        				});
	        },

	        showLockNumberForm: function() {
	        	let vm = this;

	        	$("#tangcoForm").on('show.bs.modal', function () {
	        		if(vm.selectedRecord){
	        			$('#gameSelection').val(vm.selectedRecord.game_id).trigger('change');
	        			$('#channelSelection').val(vm._generateSelectedChannel(vm.selectedRecord.channel_id)).trigger('change');
		        		$('#propSelection').val(vm.selectedRecord.prop_id).trigger('change');
		        		$('#_number').val(vm.selectedRecord.number.join(","));
		        		$('#limit').val(vm.selectedRecord.limit);
		        		vm.subCode = vm.selectedRecord.user_code.replace(vm.user.code, "");
	        		}
				});

	        	$("#tangcoForm").on('hide.bs.modal', function () {
	        		vm.selectedRecord = null;
	        		$('#channelSelection').val(null).trigger('change');
	        		$('#propSelection').val(null).trigger('change');
	        		$('#gameSelection').val(null).trigger('change');
	        		$('#_number').val("");
	        		$('#limit').val("");
	        		vm.subCode = "";
	        	});
	        	$("#tangcoForm").modal('show');
	        },

	        doLockNumber: function(){
	        	let vm = this;

	        	let limit = $('#limit').val();
	        	let channel = $('#channelSelection').val();
        		let prop = $('#propSelection').val();
        		let game = $('#gameSelection').val();
        		let number = $('#_number').val();
        		let userCode = vm.subCode;

        		window.axios.post("admin-panel/tools/daily-locknumber", {
        			userCode: vm.user.code + userCode,
        			game: game,
        			channel: channel.join(","),
        			prop: prop.join(","),
        			number: number,
        			limit: limit
        		})
			    .then((response) => {
			    	if(response.data.code == 0){
			    		swal("", "Tạo cấu hình thành công", "success");
			    		vm.getDailyLockNumber();
			    		$("#tangcoForm").modal('hide');
			    	}
			    })
			    .catch((error) => { });
	        },

	        editDailyLockNumber: function(code, e){
	        	let id = $(e.currentTarget).attr("rid");
	        	let c = this.locks.filter((x) => { return x.id == id; });
	        	this.selectedRecord = c[0];
	        	this.showLockNumberForm();
	        },

	        deleteRowLockNumber: function(code, e){
	        	let id = $(e.currentTarget).attr("rid");
	        	let vm = this;

	        	swal({"text": "Ban co chac chan muon xoa config nay?", "type": "warning", confirmButtonText: "Xoa"})
	        		.then((result) => {
	        			if(result.value){
	        				vm.deleteRow(id);
	        			}
	        		});
	        },

	        deleteRow: function(rId){
	        	let vm = this;
	        	
	        	window.axios.delete("admin-panel/tools/daily-locknumber/"+rId)
				    .then((response) => {
				    	if(response.data.code == 0){
				    		vm.getDailyLockNumber();
				    		$("#tangcoForm").modal('hide');
				    		swal("", "Xoa cấu hình thành công", "success");
				    	}
				    })
				    .catch((error) => { });
	        },

	        _generateSelectedChannel: function(channels){
	        	let cs = [];
				for(let i=0;i<channels.length;i++){
					let channel = [];
					for(let j=0;j<channels[i].length;j++){
						channel.push(channels[i][j]);
					}

					cs.push(channel.join("."))
				}
				
				return cs;
	        }
	    }
	}

</script>